module.exports = __webpack_public_path__ + "static/jobs-be913806dbc25023e3cdbce2a493f397.svg";